import React, { useMemo, useEffect, useState } from "react";
import { Card, Row, Col, Skeleton, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchStatusCounts } from "../../Redux/Slice/Doctor/Patients";
import DoctorAppointments from "./Appointment";

const { Title } = Typography;

const DoctorDashboard = () => {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));
  const doctorId = user?.doctorId;

  const { data, loading } = useSelector((state) => state.patient.statusCounts);

  const [selectedStatus, setSelectedStatus] = useState("");
  const [trigger, setTrigger] = useState(false);

  useEffect(() => {
    if (doctorId) {
      dispatch(fetchStatusCounts(doctorId));
    }
  }, [dispatch, doctorId, trigger]);

  const stats = useMemo(() => {
    return {
      total: data?.data?.TotalPatient || 0,
      booked: data?.data?.Booked || 0,
      confirmed: data?.data?.Confirmed || 0,
      pending: data?.data?.Unconfirmed || 0,
      cancelled: data?.data?.Cancelled || 0,
      rejected: data?.data?.Rejected || 0,
    };
  }, [data]);

  const cardStyle = {
    textAlign: "center",
    borderRadius: "10px",
    padding: "12px",
    minHeight: "110px",
    maxHeight: "110px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    cursor: "pointer", // 🔹 clickable
  };

  const statCards = [
    {
      title: "Total",
      value: stats.total,
      bg: "#e6f7ff",
      color: "#1890ff",
      status: "",
    },
    {
      title: "Booked",
      value: stats.booked,
      bg: "#f6ffed",
      color: "#52c41a",
      status: "Booked",
    },
    {
      title: "Confirmed",
      value: stats.confirmed,
      bg: "#f0f5ff",
      color: "#2f54eb",
      status: "Confirmed",
    },
    {
      title: "Pending",
      value: stats.pending,
      bg: "#fffbe6",
      color: "#faad14",
      status: "Pending",
    },
    {
      title: "Cancelled",
      value: stats.cancelled,
      bg: "#fff1f0",
      color: "#f5222d",
      status: "Cancelled",
    },
    {
      title: "Rejected",
      value: stats.rejected,
      bg: "#f9f0ff",
      color: "#722ed1",
      status: "Rejected",
    },
  ];

  return (
    <div>
      <Row gutter={12} style={{ marginBottom: 20 }}>
        {statCards.map((card, index) => (
          <Col span={4} key={index}>
            <Card
              bordered={false}
              style={{
                ...cardStyle,
                backgroundColor:
                  selectedStatus === card.status ? "#d6e4ff" : card.bg,
              }}
              onClick={() => setSelectedStatus(card.status)}
            >
              {loading ? (
                <Skeleton active paragraph={false} title={{ width: "50%" }} />
              ) : (
                <>
                  <Title
                    level={5}
                    style={{ marginBottom: 4, color: "#595959" }}
                  >
                    {card.title}
                  </Title>
                  <Title level={3} style={{ margin: 0, color: card.color }}>
                    {card.value}
                  </Title>
                </>
              )}
            </Card>
          </Col>
        ))}
      </Row>

      {/* Pass selectedStatus to DoctorAppointments */}
      <DoctorAppointments
        filterStatus={selectedStatus}
        setTrigger={setTrigger}
      />
    </div>
  );
};

export default DoctorDashboard;
